<template>
  <!-- Contact form-->
  <div class="bg-light rounded-3 py-5 px-4 px-md-5 mb-5">
    <div class="text-center mb-3">
      <h1>SETUP Control Acceso</h1>
    </div>
    <div class="row gx-5 justify-content-center">
      <div class="col-lg-8 col-xl-6">
        <form id="contactForm" @submit="checkForm">

          <div class="form-floating mb-3">

          </div>
          <div class="mb-3">
            <label class="form-label" style="width: 100%;">
              Áreas predeterminadas
              <button class="btn btn-primary btn-sm" style="float: right;" type="button" title="Agregar otra área" @click="addArea()">
                <FontAwesomeIcon :icon="faPlus()"/>
              </button>
            </label>

            <div class="input-group" v-for="(area, index)  in areas"  :key="area">
              <input class="form-control"
                     type="number"
                     placeholder="Área predeterminada"
                     required
                     v-model="areas[index]"
              />
              <button class="input-group-text" type="button" title="Quitar ésta área"
              @click="areas.splice(index, 1)">
                <FontAwesomeIcon :icon="faClose()"/>
              </button>
            </div>
            <div class="invalid-feedback" v-if="errors.msj != null">{{ errors.msj }}</div>
          </div>

          <div class="d-grid">
            <button class="btn btn-primary btn-lg" id="submitButton" type="submit">
              Actualizar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {inject} from "vue";
import {faClose, faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
  name: 'Login-Component',
  components: {
    FontAwesomeIcon
  },
  setup() {
    const $localStorageService = inject('$localStorageService');

    return {
      srv_localStorageService: $localStorageService
    }
  },
  data() {
    return {
      errors: {},
      areas: [],
    }
  },
  created() {
  },
  async mounted() {
    this.areas = this.srv_localStorageService.getAreaPredeterminada();
console.info(this.areas)
    if (this.areas.length < 1) {
      this.addArea();
    }

  },
  methods: {
    actualizaValor(event, index) {
      this.areas[index] = event.target.data
    },
    faPlus() {
      return faPlus
    },
    faClose() {
      return faClose
    },
    addArea() {
      this.areas.push(1)
    },
    async checkForm(e) {
      e.preventDefault();

      this.errors = {
        hasErrors: false,
        msj: null,
      };

      if (!this.areas || this.areas.length<1) {
        this.errors.hasErrors = true;
        this.errors.msj = 'Debes agregar almenos una área predeterminada.';
      }

      if (!this.errors.hasErrors) {
        this.srv_localStorageService.setAreaPredeterminada(this.areas);
        this.$swal('Se actualizo correctamente tu configuración!!!').then(()=>{
          this.$router.push({name: 'inicio'}).then(() => {
            this.$router.go(0);
          });

        });

      }
    }
  },
  filters: {

  }
};
</script>

<style scoped>

</style>
